export default __webpack_public_path__ + "static/media/zdh_video_01.3390cf1d.webp";